module.exports = __webpack_public_path__ + "img/Logo_TSG-Bochum300x265transparent.0127ae24.png";